import { cn } from "@/lib/utils";

export function Sidebar({ title, subtitle, items, active, onSelect, footer }) {
  return (
    <aside
      className="hidden lg:flex w-64 shrink-0 lg:h-[calc(100vh-4rem)] lg:sticky lg:top-16 border-r flex-col"
      style={{ background: "var(--surface)", borderColor: "var(--border)" }}
      data-testid="app-sidebar"
    >
      {title && (
        <div className="px-5 py-5 border-b" style={{ borderColor: "var(--border)" }}>
          <div className="font-heading text-lg font-bold leading-none" style={{ color: "var(--text)" }}>
            {title}
          </div>
          {subtitle && (
            <div className="text-xs mt-1" style={{ color: "var(--text-muted)" }}>
              {subtitle}
            </div>
          )}
        </div>
      )}
      <nav className="flex flex-col gap-1 p-3">
        {items.map((it) => {
          if (it.group) {
            return (
              <div
                key={it.key}
                className="px-3.5 pb-1 pt-4 text-[10px] font-bold uppercase tracking-[0.2em] first:pt-1"
                style={{ color: "var(--text-muted)" }}
              >
                {it.label}
              </div>
            );
          }
          const on = active === it.key;
          const Icon = it.icon;
          return (
            <button
              key={it.key}
              data-testid={`sidebar-nav-${it.key}`}
              onClick={() => onSelect(it.key)}
              className={cn(
                "flex items-center gap-3 px-3.5 py-2.5 text-sm font-medium transition-all whitespace-nowrap",
                on ? "shadow-sm" : "hover:opacity-80"
              )}
              style={{
                borderRadius: "var(--radius)",
                background: on ? "var(--primary)" : "transparent",
                color: on ? "var(--primary-fg)" : "var(--text)",
              }}
            >
              {Icon && <Icon className="h-4 w-4 shrink-0" />}
              <span>{it.label}</span>
              {it.badge > 0 && (
                <span
                  className="ml-auto text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                  style={{
                    background: on ? "var(--primary-fg)" : "var(--accent)",
                    color: on ? "var(--primary)" : "var(--accent-fg)",
                  }}
                >
                  {it.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>
      {footer && <div className="mt-auto p-3 hidden lg:block">{footer}</div>}
    </aside>
  );
}
